<template>
    <v-main>
        <LoadingScreen v-if="isLoadingScreen" />
        <div class="sport" v-else>
            <div class="sport__header">
                <div class="sport_home" @click="$router.push('/')">
                    <img src="~ThemePath/images/chevron-left-green.png" />
                    <span class="sport_text">{{
                        getTranslatedText("home")
                    }}</span>
                </div>
                <span class="sport_text sports">{{
                    getTranslatedText("sports")
                }}</span>
            </div>
            <div class="sport__iframe">
                <iframe :src="iframeUrl"></iframe>
            </div>
        </div>
    </v-main>
</template>

<script>
import LoadingScreen from "@/components/common/loading/index.vue";
import languageMixins from "@/mixins/language/language-mixins";
import printMixins from "@/mixins/print/print-mixins";
import { getAccessToken } from "@/services/axios";
import { getSettingDevice, isStrEmpty, formatPrice } from "@/utils/utils";

const SETTING_JSON = process.env.VUE_APP_SETTING_JSON;
const IS_BROWSER_TESTING = process.env.VUE_APP_IS_BROWSER_TESTING;

export default {
    mixins: [languageMixins, printMixins],
    components: { LoadingScreen },
    data() {
        return {
            isLoadingScreen: false,
            iframeUrl: "",
        };
    },
    mounted() {
        this.renderIframe();
        window.addEventListener("message", this.handleIframeMessage);
    },
    beforeDestroy() {
        window.removeEventListener("message", this.handleIframeMessage);
    },
    methods: {
        handleIframeMessage(event) {
            if (
                event.data.type === "cashout" &&
                event.data.action === "print"
            ) {
                this.printSports(event.data.data);
            }
        },

        renderIframe() {
            let setting = getSettingDevice();
            if (IS_BROWSER_TESTING && Boolean(parseInt(IS_BROWSER_TESTING)) && isStrEmpty(setting)) {
                const SETTING_ENV = JSON.parse(SETTING_JSON);
                setting = JSON.parse(setting);
                const token = getAccessToken();
                this.iframeUrl = `${
                    SETTING_ENV.url
                }/retail/sport-page-for-pos/index?locale=fr&admin_jwt=${token}&t=${Date.now()}&device_network_mac_address=browser&app_version=browser.1&device_serial_number=browser.serial&device_unique_id=browser.unique&toggleTournaments=false`;
            } else {
                if (!isStrEmpty(setting)) {
                    const SETTING_ENV = JSON.parse(SETTING_JSON);
                    setting = JSON.parse(setting);
                    const token = getAccessToken();
                    this.iframeUrl = `${
                        SETTING_ENV.url
                    }/retail/sport-page-for-pos/index?locale=fr&admin_jwt=${token}&t=${Date.now()}&device_network_mac_address=${
                        setting.mac
                    }&app_version=${setting.appVersion}&device_serial_number=${
                        setting.serial
                    }&device_unique_id=${
                        setting.uniqueId
                    }&toggleTournaments=false`;
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import "~ThemePath/scss/sport/_index.scss";
</style>
